import { StyleSheet, Dimensions } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const screenWidth = Dimensions.get('screen').width;

export default StyleSheet.create({
  iconImage: {
    paddingTop: 2,
  },
  paymentMethod: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
  },
  titleStyle: theme => ({
    color: theme.colors.headerColor,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 24,
    marginBottom: 12,
  }),
  edit: {
    color: Colors.secondary7,
    fontSize: 16.6,
    marginRight: 8,
  },
  editView: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  addCardContainer: {
    marginBottom: 17,
  },
  paymentMethodContentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  footerBorder: theme => ({
    borderBottomColor: theme.colors.fillColor,
    borderBottomWidth: 1,
    flex: 1
  }),
  widthAdjustment: {
    width: '100%',
    // marginHorizontal: 16,
  },
});
